import { Component, OnInit } from '@angular/core';
import { Router }            from '@angular/router';

import { HubsService } from '@services/hubs.service';
import { AuthUser }    from '@models/user/auth-user';


@Component({
    selector: 'red-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss'],
    standalone: false
})
export class RedirectComponent implements OnInit {

  constructor(
    private hubsService: HubsService,
  ) { }

  private checkRoute = (user: AuthUser, router: Router) => {
    router.navigate([ this.hubsService.getHomeRoute(user) ]).then();
  }

  ngOnInit(): void {
    this.hubsService.checkUserType(this.checkRoute);
  }

}
